<template>
  <div class="component-wrapper container d-flex flex-column align-center mt-8">
    <Breadcrumb
      class="breadcrumb"
      :breadcrumbItems="breadCrumbItems"
      :hcmcReportDate="currentHcmcReportDate"
    />
    <div class="container mt-2 d-flex flex-column align-center">
      <div class="align-self-sm-start align-self-center mb-8 mb-sm-8 mb-md-16">
        <div class="text-sm-body-1 font-weight-regular">Κατάσταση: Έγκυρη</div>
        <div
          v-if="
            currentHcmcReport.submissionStatus != 'submittedToHCMC' &&
            currentHcmcReport.lastValidationMessage !== undefined
          "
          class="text-sm-body-1 font-weight-regular"
        >
          Σχόλια Ε.Κ: {{ currentHcmcReport.lastValidationMessage }}
        </div>
      </div>
      <div
        class="
          d-flex
          flex-sm-row flex-column
          mb-sm-4 mb-2
          justify-md-space-between justify-center
          align-center
          container
        "
      >
        <v-btn
          class="
            mr-md-0 mr-sm-4
            mb-sm-0 mb-2
            primary
            rounded
            text-sm-body-1
            font-weight-regular
            button
          "
          @click="onSave"
          >Λήψη αρχείου</v-btn
        >
        <v-btn
          class="primary rounded text-sm-body-1 font-weight-regular button"
          @click="onShow"
          >Προβολή αρχείου</v-btn
        >
        <v-btn
          class="
            primary
            rounded
            text-sm-body-1
            font-weight-regular
            button
            d-none d-md-flex
          "
          :to="`/hcmc/pending/${currentHcmcReport.reportId}/history`"
          >Ιστορικό ενεργειών</v-btn
        >
      </div>
      <div
        class="
          d-flex
          flex-sm-row flex-column
          mb-sm-4 mb-2
          justify-md-space-between justify-center
          align-center
          container
        "
      >
        <v-btn
          class="
            primary
            rounded
            text-sm-body-1
            font-weight-regular
            button
            d-md-none d-flex
            mr-md-0 mr-sm-4
            mb-sm-0 mb-2
          "
          :to="`/hcmc/pending/${currentHcmcReport.reportId}/history`"
          >Ιστορικό ενεργειών</v-btn
        >
        <v-btn
          v-if="currentHcmcReport.submissionStatus == 'submittedToHCMC'"
          class="primary rounded text-sm-body-1 font-weight-regular button"
          @click="onCorrection"
          :disabled="userRole == 'viewer'"
          >Επιστροφή για διόρθωση</v-btn
        >
      </div>
    </div>
    <div>
      <v-btn
        to="/hcmc/pending/reports"
        class="
          secondary
          rounded
          text-sm-body-1
          font-weight-regular
          mt-sm-16 mt-8
        "
        >Επιστροφή</v-btn
      >
    </div>
    <v-dialog min-width="auto" v-model="dialog">
      <ShowReport v-if="dialog" />
    </v-dialog>
    <v-dialog min-width="500px" v-model="correctionDialog">
      <SendCorrections v-if="correctionDialog" />
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb.vue";
import ShowReport from "../../components/Modals/ShowReport.vue";
import SendCorrections from "../../components/Modals/SendCorrections.vue";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  components: {
    Breadcrumb,
    ShowReport,
    SendCorrections,
  },

  created() {
    this.breadCrumbItems[2].text = `${new Date(
      this.currentHcmcReport.lastUploadedVersionDate
    ).toLocaleDateString("el")}`;
  },
  data() {
    return {
      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "hcmc",
        },
        {
          text: "Εκκρεμμείς Εκθέσεις ΑΕΔΑΚ",
          disabled: false,
          to: "/hcmc/pending/reports",
        },
        {
          disabled: true,
          to: "/hcmc/pending",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      userRole: (state) => state.auth.userRole,

      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
      savedReport: (state) => state.reports.savedReport,
    }),

    dialog: {
      get() {
        return this.$store.state.dialogs.showReportDialog;
      },
      set(value) {
        return this.updateShowReportDialog(value);
      },
    },

    correctionDialog: {
      get() {
        return this.$store.state.dialogs.sendCorrectionsDialog;
      },
      set(value) {
        return this.updateSendCorrectionsDialog(value);
      },
    },

    ...mapGetters(["currentHcmcReportDate"]),
  },

  methods: {
    ...mapMutations(["updateShowReportDialog", "updateSendCorrectionsDialog"]),
    ...mapActions(["getSavedReport"]),
    async onSave() {
      try {
        await this.getSavedReport(this.currentHcmcReport.lastUploadedVersionId);

        const filename = this.savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([this.savedReport.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.click();
      } catch {}
    },

    onShow() {
      this.updateShowReportDialog(true);
    },

    onCorrection() {
      this.updateSendCorrectionsDialog(true);
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb,
.container {
  width: 950px;
}

.button {
  width: 300px;
}

@media only screen and (max-width: 960px) {
  .breadcrumb,
  .container {
    width: 800px;
  }
}

@media only screen and (max-width: 600px) {
  .breadcrumb,
  .container {
    width: 100%;
  }
}
</style>